<div class="p-grid w-100">
	<div class="p-col-12 p-md-4">
		<div class="d-flex flex-column card">
			<div class="display-10">sales</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="4rem"></p-skeleton>
			<div class="display-6 d-flex flex-column" *ngIf="metrics.loadComplete">
				<div class="ms-2">
					{{ currentDaySalesSummary?.netSales | currency }}
				</div>

				<div *ngIf="metrics.netSalesPercent > 0" class="fl-text-success display-14 mt-auto ms-2">
					{{ metrics.netSalesPercent | percent }} <fa-icon [icon]="['fas', 'up']"></fa-icon> last
					{{ currentDaySalesSummary.averages.netSalesCalculationDays }} days
				</div>
				<div *ngIf="metrics.netSalesPercent === 0" class="fl-text-secondary display-14 mt-auto ms-2">
					{{ metrics.netSalesPercent | percent }} <fa-icon [icon]="['fas', 'hyphen']"></fa-icon> last
					{{ currentDaySalesSummary.averages.netSalesCalculationDays }} days
				</div>
				<div *ngIf="metrics.netSalesPercent < 0" class="fl-text-danger display-14 my-auto ms-2">
					{{ metrics.netSalesPercent | percent }} <fa-icon [icon]="['fas', 'down']"></fa-icon> last
					{{ currentDaySalesSummary.averages.netSalesCalculationDays }} days
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-4">
		<div class="d-flex flex-column card">
			<div class="display-10">checks</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="4rem"></p-skeleton>
			<div class="display-6 d-flex flex-column" *ngIf="metrics.loadComplete">
				{{ currentDaySalesSummary?.checkCount }}
				<div *ngIf="metrics.checkCountPercent > 0" class="fl-text-success display-14 mt-auto ms-2">
					{{ metrics.checkCountPercent | percent }} <fa-icon [icon]="['fas', 'up']"></fa-icon> last
					{{ currentDaySalesSummary.averages.checkCountCalculationDays }} days
				</div>
				<div *ngIf="metrics.checkCountPercent === 0" class="fl-text-secondary display-14 mt-auto ms-2">
					{{ metrics.checkCountPercent | percent }} <fa-icon [icon]="['fas', 'hyphen']"></fa-icon> last
					{{ currentDaySalesSummary.averages.checkCountCalculationDays }} days
				</div>
				<div *ngIf="metrics.checkCountPercent < 0" class="fl-text-danger display-14 my-auto ms-2">
					{{ metrics.checkCountPercent | percent }} <fa-icon [icon]="['fas', 'down']"></fa-icon> last
					{{ currentDaySalesSummary.averages.checkCountCalculationDays }} days
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-4">
		<div class="d-flex flex-column card">
			<div class="display-10">average check</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="4rem"></p-skeleton>
			<div class="display-6 d-flex flex-column" *ngIf="metrics.loadComplete">
				{{ currentDaySalesSummary?.averageCheck | currency }}
				<div *ngIf="metrics.averageCheckPercent > 0" class="fl-text-success display-14 mt-auto ms-2">
					{{ metrics.averageCheckPercent | percent }} <fa-icon [icon]="['fas', 'up']"></fa-icon> last
					{{ currentDaySalesSummary.averages.checkCalculationDays }} days
				</div>
				<div *ngIf="metrics.averageCheckPercent === 0" class="fl-text-secondary display-14 mt-auto ms-2">
					{{ metrics.averageCheckPercent | percent }} <fa-icon [icon]="['fas', 'hyphen']"></fa-icon> last
					{{ currentDaySalesSummary.averages.checkCalculationDays }} days
				</div>
				<div *ngIf="metrics.averageCheckPercent < 0" class="fl-text-danger display-14 my-auto ms-2">
					{{ metrics.averageCheckPercent | percent }} <fa-icon [icon]="['fas', 'down']"></fa-icon> last
					{{ currentDaySalesSummary.averages.checkCalculationDays }} days
				</div>
			</div>
		</div>
	</div>
</div>

<div class="p-grid">
	<div class="p-col-12 p-md-3">
		<div class="d-flex flex-column card mt-1">
			<div class="d-flex">
				<div class="ms-auto">
					<p-selectButton
						[options]="orderTypeMealPeriodOption"
						optionValue="value"
						optionLabel="label"
						[(ngModel)]="orderTypeMealPeriodViewSelected"
					></p-selectButton>
				</div>
			</div>

			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="10rem"></p-skeleton>
			<app-order-type-meal-period-widget
				*ngIf="metrics.loadComplete"
				[(checkDate)]="checkDate"
				[(currentDaySalesSummary)]="currentDaySalesSummary"
				[(orderTypeMealPeriodViewSelected)]="orderTypeMealPeriodViewSelected"
			></app-order-type-meal-period-widget>
		</div>
	</div>
	<div class="p-col-12 p-md-9">
		<div class="d-flex flex-column card mt-1">
			<div class="d-flex">
				<div class="ms-auto">
					<p-selectButton
						[options]="salesGuestViewOption"
						optionValue="value"
						optionLabel="label"
						[(ngModel)]="salesGuestViewSelected"
					></p-selectButton>
				</div>
			</div>

			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="10rem"></p-skeleton>
			<app-sales-guest-widget
				*ngIf="metrics.loadComplete"
				[(checkDate)]="checkDate"
				[(currentDaySalesSummary)]="currentDaySalesSummary"
				[(salesGuestViewSelected)]="salesGuestViewSelected"
			></app-sales-guest-widget>
		</div>
	</div>
</div>
